import { render, staticRenderFns } from "./ScreenshareEditor.vue?vue&type=template&id=0ef2c0f3&"
import script from "./ScreenshareEditor.vue?vue&type=script&lang=ts&"
export * from "./ScreenshareEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports